import { Component } from "react";
import { Button, Icon, Tooltip, ButtonGroup } from "@shopify/polaris";
import {
	ChevronLeftMinor,
	ChevronRightMinor,
	TypeMajor,
	AddImageMajor,
	MobilePlusMajor,
	MinusMinor,
	SearchMajor,
	MobileBackArrowMajor,
	DuplicateMinor,
} from "@shopify/polaris-icons";
import { fabric } from "fabric";
import ReactDOMServer from "react-dom/server";
import ActiveObjectToolbar from "./ActiveObjectToolbar";
import UploadModal from "../../../components/UploadModal";
import AddVariable from "./AddVariable";
import NameModal from "./NameModal";
import Table from "../../../components/Table";

class Toolbar extends Component {
	constructor(props) {
		super(props);
		this.state = {};
		// eslint-disable-next-line react/no-unused-class-component-methods
		this.canvases = [];
	}

	cancel() {
		this.props.history.push(`/admin/pdf_templates/${this.props.id}`);
	}

	openModal(name) {
		this.setState({ [name]: true });
	}

	closeModal(name) {
		if (name === "variable" && !this.state["variable-input-focused"]) {
			this.setState((c) => ({ [name]: false, input: "" }));
			return;
		}
		this.setState((c) => ({ [name]: false }));
	}

	// eslint-disable-next-line react/no-unused-class-component-methods
	updateForm(field, value) {
		this.setState({ [field]: value });
	}

	addVariable(input = this.state.input, type, data) {
		if (type === "profile") {
			this.props.addImage(["https://itbmedia.kund24.se/assets/pdf_profile_placeholder.jpeg"], (img) => {
				const d = 500;
				const size = 40 / d;

				return {
					centeredScaling: true,
					top: 100,
					left: 100,
					originX: "center",
					originY: "center",
					scaleX: size * this.props.zoom,
					scaleY: size * this.props.zoom,
					clipPath: new fabric.Circle({
						radius: d / 2,
						originX: "center",
						originY: "center",
					}),
				};
			});

			return;
		}
		if (type === "table") {
			const rows = Array.from(Array(parseInt(data))).map((i, index) => index);
			this.props.addAnything(ReactDOMServer.renderToStaticMarkup(<Table placeholder rows={rows} />), {
				height: rows.length * 20 + 75,
				numRows: parseInt(data || 10) || 10,
				left: 0,
				top: 250,
			});

			return;
		}

		this.props.addText(`{{${input}}}`);
		this.setState({ input: "" });
	}

	render() {
		return (
			<div className="editor__toolbar">
				<div>
					<div className="editor__toolbar__leftButtons">
						<Button icon={MobileBackArrowMajor} onClick={this.cancel.bind(this)}>
							tillbaka
						</Button>
					</div>
					<span className="editor__toolbar__newPageBtn">
						<Button primary onClick={this.props.addPage}>
							+ Sida
						</Button>
					</span>

					<ButtonGroup>
						<Tooltip content="Lägg till text">
							<Button onClick={this.props.addText.bind(this, "Text")} icon={TypeMajor} />
						</Tooltip>

						<AddVariable addVariable={this.addVariable.bind(this)} />
						<Tooltip content="Lägg till en bild">
							<Button onClick={this.openModal.bind(this, "openUploadImage")} icon={AddImageMajor} />
						</Tooltip>
						<Tooltip content="Lägg till en linje">
							<Button onClick={this.props.addLine}>|</Button>
						</Tooltip>
					</ButtonGroup>
					<Tooltip content="Duplicera valt objekt">
						<Button onClick={this.props.duplicateObject} icon={DuplicateMinor} />
					</Tooltip>
					<div className="editor__toolbar__buttonGroup">
						<button className="prev" onClick={this.props.gotoPrevPage} disabled={this.props.activePageNr === 0}>
							<Icon source={ChevronLeftMinor} />
						</button>
						<div className="nr">{this.props.activePageNr + 1}</div>
						<button
							className="next"
							onClick={this.props.gotoNextPage}
							disabled={this.props.activePageNr + 1 >= this.props.form.pages && this.props.form.pages.length}
						>
							<Icon source={ChevronRightMinor} />
						</button>
					</div>
					<div className="editor__toolbar__buttonGroup zoom">
						<button onClick={this.props.zoomOut}>
							<Icon source={MinusMinor} />
						</button>
						<span className="zoom-icon">
							<Icon source={SearchMajor} />
						</span>
						<button onClick={this.props.zoomIn}>
							<Icon source={MobilePlusMajor} />
						</button>
					</div>
					<div className="editor__toolbar__rightButtons">
						<Button
							primary
							loading={this.props.saving}
							onClick={() => {
								this.props.setZoom(1);
								if (this.props.requireName) {
									this.setState({ nameModalIsOpen: true });
									return;
								}
								this.props.onSave();
							}}
						>
							{this.props.print ? "Skriv ut" : "Spara"}
						</Button>
					</div>
				</div>
				<ActiveObjectToolbar
					canvas={this.props.canvas}
					activeObjects={this.props.activeObjects || []}
					addLastFontSize={this.props.addLastFontSize}
					addLastFontFamily={this.props.addLastFontFamily}
				/>

				<UploadModal
					open={this.state.openUploadImage}
					onClose={this.closeModal.bind(this, "openUploadImage")}
					onSelect={(imgs) => {
						const urls = [imgs].flat(1).map(({ url } = {}) => url);
						this.props.addImage(urls);
						this.closeModal("openUploadImage");
					}}
				/>

				<NameModal
					saving={this.props.saving}
					onSave={this.props.onSave}
					open={this.state.nameModalIsOpen}
					onClose={() => this.setState({ nameModalIsOpen: false })}
				/>
			</div>
		);
	}
}

export default Toolbar;
